import { validatePHQuiz } from './planetHoppers';

export const SETUP_MODES = ['relic-run', 'picture-detectives', 'vault-breakers', 'planet-hoppers'] as const;
export type SetupMode = typeof SETUP_MODES[number];
export type SavedSetup = {
    format: 'ziarcadia-setup'; version: 1; mode: SetupMode; title: string; sourceText: string;
    settings: { singleLineMode: boolean; hostParticipates: boolean; pictionaryStem: string; pictionaryNoHints: boolean; pictionaryNoTranslations: boolean; pictionarySameStem: boolean; pictionaryHostIsController: boolean };
};
export type SetupLibraryItem = { id: string; title: string; mode: SetupMode; revision: number; updatedAt: number; preview: string; source?: string };
export function validateSavedSetup(value: unknown): SavedSetup {
    if (!value || typeof value !== 'object') throw new Error('Invalid setup');
    const v = value as Record<string, unknown>;
    if (v.format !== 'ziarcadia-setup' || v.version !== 1 || !SETUP_MODES.includes(v.mode as SetupMode)
        || typeof v.title !== 'string' || !v.title.trim() || v.title.length > 120
        || typeof v.sourceText !== 'string' || !v.sourceText.trim() || v.sourceText.length > 600_000) throw new Error('Invalid setup');
    const settings = v.settings as Record<string, unknown>;
    const keys = ['singleLineMode', 'hostParticipates', 'pictionaryNoHints', 'pictionaryNoTranslations', 'pictionarySameStem', 'pictionaryHostIsController'] as const;
    if (!settings || keys.some(key => typeof settings[key] !== 'boolean') || typeof settings.pictionaryStem !== 'string' || settings.pictionaryStem.length > 120) throw new Error('Invalid settings');
    let sourceText = v.sourceText;
    if (v.mode === 'planet-hoppers') {
        const quiz = validatePHQuiz(JSON.parse(sourceText));
        for (const q of quiz.questions) for (const media of [q.image, ...q.after]) {
            if (media) media.url = media.url.replace(/^\/api\/rooms\/[A-Z0-9]+\/ph-media\//, '/api/planet-media/');
        }
        sourceText = JSON.stringify(quiz);
    }
    return { format: 'ziarcadia-setup', version: 1, mode: v.mode as SetupMode, title: v.title.trim(), sourceText,
        settings: { ...Object.fromEntries(keys.map(key => [key, settings[key]])) as Omit<SavedSetup['settings'], 'pictionaryStem'>, pictionaryStem: settings.pictionaryStem } };
}
export function setupPreview(setup: SavedSetup): string[] {
    if (setup.mode === 'planet-hoppers') return validatePHQuiz(JSON.parse(setup.sourceText)).questions.slice(0, 3).map(q => q.prompt || '…');
    return setup.sourceText.split(/\r?\n/).filter(line => line.trim()).slice(0, 3).map(line => line.slice(0, 180));
}
